document.addEventListener("turbo:frame-missing", (event) => {
  console.error("Frame missing", event)

  event.preventDefault()
})
